import styled from '@emotion/styled'

export const InvoiceTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 50%;
`
